<template>
    <div class="listener-detail">
        <div class="jc-cloud-mask" v-if="descriptionFlag || nameFlag"></div>
        <div class="jc-page-top">
            <div class="jc-page-header">
                <el-page-header show-back-icon :title="$t('slb.text.listener')" @back="jumpToUp()" class="relative">
                    <template slot="content">
                        <span class="long-name" :title="detailData.name">
                            {{detailData.name}}
                        </span>                     
                        <div class="jc-list__header--right jc-box-action">
                            <!--帮助文档-->
                            <a :href="Config.SLB_HELP_URL" target="_blank">
                                {{$t('slb.text.slbHelpDoc')}}
                            </a>
                            <!--操作-->
                            <el-dropdown @command="selectOps">
                                <el-button class="operate-select">
                                  {{ $t('operations.operate') }}<i class="jc-icon-caret-bottom jc-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="item.ifShow" v-for="(item,index) in availableOperatesArray"
                                        :key="index"
                                        :command="item" class="jc-select-form-item">
                                        {{item.name}}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-page-header>
            </div>
            <div class="jc-page-content">
                <el-tabs type="border-card" v-model="activeTab"
                    @tab-click="changeTab">
                    <!-- 资源信息 -->
                    <el-tab-pane 
                        :label="$t('detail.text.sourceInfo')" name="source"
                        :disabled="activeTab==='source'">
                        <!-- 基本信息 -->
                        <div class="jc-section">
                            <div class="jc-section-header">
                                <h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
                            </div>
                            <div class="jc-section-content">
                                <el-form class="jc-datashow-list jc-datashow-list-inline align-left"
                                    :model="editObj" ref="editObj" :rules="rules" @submit.native.prevent>
                                    <el-row :gutter="20">
                                        <!--名称-->
                                        <!--编辑描述的时候显示-->
                                        <el-col :span="8" v-if='descriptionFlag'>
                                            <el-form-item :label="$t('slb.text.name') | withColon"
                                                class="jc-form-description">
                                                <p>{{detailData.name}}
                                                    <el-button type="text" icon="jc-icon-edit"
                                                        @click="setEdit('name',detailData.name)"
                                                        :disabled="detailData.name === undefined">
                                                    </el-button>
                                                </p>
                                            </el-form-item>
                                        </el-col>
                                        <!--名称-->
                                        <!--没有编辑描述的时候显示-->
                                        <el-col :span="8" v-if='!descriptionFlag'>
                                            <el-form-item :label="$t('slb.text.name') | withColon"
                                                class="jc-form-description" prop="editName"
                                                :show-message="false" ref="editName">
                                                <p>
                                                    {{detailData.name}}
                                                    <el-button type="text" icon="jc-icon-edit"
                                                        @click="setEdit('name',detailData.name)"
                                                        :disabled="detailData.name === undefined">
                                                    </el-button>
                                                </p>
                                                <!--编辑名称的时候显示-->
                                                <div v-if="nameFlag" class="info-description">
                                                    <p class="txt">{{ $t('detail.text.modifyName')| withColon }}</p>
                                                    <el-input v-model="editObj.editName" 
                                                        class="jc-form-name-input"
                                                        @keyup.enter.native="confirmModify('name')"
                                                        :placeholder="$t('detail.placeholder.editName')"
                                                        @focus="ruleFormTag.editName = ValidOrErrorConstant.VALID"
                                                        style="width: 450px;">
                                                    </el-input>
                                                    <!--名称为空-->
                                                    <p v-if="ruleFormTag.editName !== ValidOrErrorConstant.VALID &&
                                                  editObj.editName === ''"
                                                        class="el-form-item-help-error">
                                                        {{ $t('detail.speechCraft.nameNoNull') }}
                                                    </p>
                                                    <!--名称不为空，不符合规范-->
                                                    <p v-if="ruleFormTag.editName === ValidOrErrorConstant.ERROR &&
                                                    editObj.editName !== ''"
                                                        class="el-form-item-help"
                                                        :class="{'el-form-item-help-error': this.ruleFormTag.editName ===
                                                     ValidOrErrorConstant.ERROR}">
                                                        {{$t('detail.speechCraft.editNameRule')}}
                                                    </p>
                                                    <!--按钮-->
                                                    <div class="edit-button-container">
                                                        <!--取消-->
                                                        <el-button @click="cancelDes">
                                                          {{ $t('detail.text.cancel') }}
                                                        </el-button>
                                                        <!--确定-->
                                                        <el-button type="primary"
                                                           @click="confirmModify('name')">
                                                          {{ $t('detail.text.sure') }}
                                                        </el-button>
                                                    </div>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <!--监听协议-->
                                        <el-col :span="8">
                                            <el-form-item :label="$t('slb.text.protocol') | withColon">
                                                <p>{{detailData.protocolName | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--端口-->
                                        <el-col :span="8">
                                            <el-form-item :label="$t('slb.text.port') | withColon">
                                                <p>{{detailData.port | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--调度算法-->
                                        <el-col :span="8">
                                            <el-form-item  :label="$t('slb.text.algorithm') | withColon">
                                                <p>{{detailData.algorithmName | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--会话保持-->
                                        <el-col :span="8">
                                            <el-form-item :label="$t('slb.text.stickySession') | withColon">
                                                <p>{{detailData.stickySessionName | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--http2.0-->
                                        <el-col :span="8" v-if="ifHttps">
                                            <el-form-item :label="$t('slb.text.http2') | withColon">
                                                <p>{{detailData.http2Name | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!-- 会话保持超时 -->
                                        <el-col :span="8" v-if="ifSessionOn&(ifHttp||ifHttps)">
                                            <el-form-item :label="$t('slb.text.stickySessionTimeout') | withColon">
                                                <p>{{detailData.stickySessionTimeout | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!-- 会话类型 -->
                                        <el-col :span="8" v-if="ifSessionOn&(ifHttp||ifHttps)">
                                            <el-form-item :label="$t('slb.text.sessionType') | withColon">
                                                <p>{{detailData.cookieTypeName | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--获取真实IP-->
                                        <el-col :span="8" v-if="!ifUdp">
                                            <el-form-item :label="$t('slb.text.realIp') | withColon">
                                                <p>{{detailData.realIpName | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!-- 获取HTTP头字段 -->
                                        <el-col :span="8" v-if="(ifHttp||ifHttps)">
                                            <el-form-item :label="$t('slb.text.httpHeader') | withColon">
                                                <p>{{detailData.headersName | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!-- 证书 -->
                                        <el-col :span="8" v-if="ifHttps">
                                            <el-form-item :label="$t('slb.text.certificate') | withColon">
                                                <p>{{detailData.certificateName | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </div>
                        <el-divider></el-divider>
                        <!-- 健康检查 -->
                        <div class="jc-section">
                            <div class="jc-section-header">
                                <h3 class="jc-section-title">{{$t('slb.text.healthCheck')}}</h3>
                             </div>
                            <div class="jc-section-content">
                                <el-form class="jc-datashow-list jc-datashow-list-inline">
                                    <el-row :gutter="20">
                                        <!--健康检查 -->
                                        <el-col :span="8">
                                            <el-form-item :label="$t('slb.text.healthCheck') | withColon">
                                                <p>{{ detailData.healthCheckName| maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--响应超时时间-->
                                        <el-col :span="8" v-if="ifHealthCheckOn">
                                            <el-form-item :label="$t('slb.text.healthCheckTimeout') | withColon">
                                                <p>{{detailData.healthCheckTimeout | maybeEmpty}}s</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--健康检查间隔-->
                                        <el-col :span="8" v-if="ifHealthCheckOn">
                                            <el-form-item :label="$t('slb.text.healthCheckInterval') | withColon">
                                                <p>{{detailData.healthCheckInterval | maybeEmpty}}s</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--健康阈值-->
                                        <el-col :span="8" v-if="ifHealthCheckOn">
                                            <el-form-item :label="$t('slb.text.healthCheckThreshold') | withColon">
                                                <p>{{$t('slb.text.times', [detailData.healthyThreshold])}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--不健康阈值-->
                                        <el-col :span="8" v-if="ifHealthCheckOn">
                                            <el-form-item :label="$t('slb.text.unhealthyCheckThreshold') | withColon">
                                                <p>{{$t('slb.text.times', [detailData.unhealthyThreshold])}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!-- 检查路径-->
                                        <el-col :span="8" v-if="ifHealthCheckOn&(ifHttp||ifHttps)">
                                            <el-form-item :label="$t('slb.text.healthCheckUri') | withColon">
                                                <p>{{ detailData.healthCheckUri | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!-- 正常态码 -->
                                        <el-col :span="8" v-if="ifHealthCheckOn&(ifHttp||ifHttps)">
                                            <el-form-item :label="$t('slb.text.healthCheckHttpCode') | withColon">
                                                <p>{{ detailData.healthCheckHttpCode | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                        <!--健康检查IP-->
                                        <el-col :span="8" v-if="ifHealthCheckOn">
                                            <el-form-item :label="$t('slb.text.healthCheckIp') | withColon">
                                                <p>{{ defaultHealthCheckIp | maybeEmpty}}</p>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </div>
                        <el-divider></el-divider>
                        <!-- 服务器组 -->
                        <div class="jc-section">
                            <div class="jc-section-header">
                                <h3 class="jc-section-title">{{ $t('slb.text.serverGroup') }}</h3>
                            </div>
                            <div class="jc-section-content">
                                <el-form class="jc-datashow-list jc-datashow-list-inline">
                                    <el-row :gutter="20">
                                        <el-col :span="8">
                                            <el-form-item :label="$t('slb.text.relatedServerGroup') | withColon">
                                                <a href="javascript:void(0)"
                                                    @click="jumpToServerGroupDetail">
                                                    {{serverGroupData.name}}
                                                </a>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <server-group :region="region" type="detail"
                                        :server-group-id="serverGroupData.serverGroupId"
                                        :listener-id="detailData.listenerId">
                                    </server-group>
                                </el-form>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- SNI管理 -->
                    <el-tab-pane 
                        v-if="ifHttps"
                        :label="$t('slb.text.sni')" name="sni"
                        :disabled="activeTab==='sni'">
                        <!-- sni列表 -->
                        <div class="jc-container-table">
                            <div class="jc-container-table-actionBar">
                                <!--刷新、添加-->
                                <el-form class="jc-table-actionBar-item" :inline="true">
                                    <el-form-item>
                                        <el-button icon="jc-icon-refresh-line" 
                                            class="jc-button-icon"
                                            @click="updateDomainList('refresh')">
                                        </el-button>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-tooltip :content="$t('slb.sentence.domainTotalTip')" 
                                            placement="right"
                                            :disabled="sni.total < 21"
                                            >
                                            <label>
                                                <el-button 
                                                    :disabled="sni.total === 21"
                                                    type="primary"
                                                    @click="addDomain">
                                                    {{$t('slb.text.addDomain')}}
                                                </el-button>
                                            </label>
                                        </el-tooltip>                                     
                                    </el-form-item>
                                </el-form>                         
                            </div>
                            <!--sni列表-->
                            <el-table 
                                :data="sni.listData"
                                class="jc-list-table jc-table-header-cell" 
                                v-loading="sni.refreshLoading"
                                ref="sniListTable"
                                :empty-text="$t('speechCraft.listEmptyText')">
                                <!--域名-->
                                <el-table-column 
                                    :label="$t('slb.text.domain')" 
                                    key="domain">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.domain | maybeEmpty}}</span>
                                    </template>
                                </el-table-column>
                                <!--证书-->
                                <el-table-column 
                                    :label="$t('slb.text.certificate')"
                                    key="certificate">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.certificateName | maybeEmpty}}</span>
                                    </template>
                                </el-table-column>                        
                                <!--操作-->
                                <el-table-column 
                                    key="operation"
                                    :label="$t('listPage.tableLabel.operation')">
                                    <template slot-scope="scope">
                                        <a href="javascript:void(0)"
                                            v-if="!scope.row.isDefault" 
                                            @click="modifyDomain(scope.row)">
                                            {{$t('slb.operations.edit.name')}}
                                        </a>
                                        <a href="javascript:void(0)" 
                                            v-if="!scope.row.isDefault" 
                                            @click="deleteDomain(scope.row)">
                                            {{$t('slb.operations.delete.name')}}
                                        </a>
                                    </template>
                                </el-table-column>
                            </el-table> 
                        </div>
                        <div v-if="sni.total"
                            class="cps-page-footer-simple jc-container-table-actionBar">
                            <el-pagination 
                                @size-change="handleSniSizeChange" @current-change="handleSniCurrentChange"
                                :current-page="sni.currentPage"
                                :page-sizes="sni.pageSizes" :page-size="sni.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="sni.total">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <!-- 访问控制 -->
                    <el-tab-pane 
                        v-if="ifHttp || ifHttps"
                        :label="$t('slb.text.accessControl')" name="access"
                        :disabled="activeTab==='access'">
                        <!-- acl规则列表 -->
                        <div class="jc-container-table">
                            <div class="jc-container-table-actionBar">
                                <!--管理策略-->
                                <el-form class="jc-table-actionBar-item" :inline="true">
                                    <el-form-item>
                                        <el-button type="primary"
                                            @click="manageStrategy">
                                            {{$t('slb.text.manageStrategy')}}
                                        </el-button>
                                    </el-form-item>
                                </el-form>                         
                            </div>
                            <!--acl列表-->
                            <el-table 
                                :data="acl.listData"
                                class="jc-list-table jc-table-header-cell jc-acl-list-table" 
                                v-loading="acl.refreshLoading"
                                ref="aclListTable"
                                :max-height="acl.maxHeight"
                                :empty-text="$t('speechCraft.listEmptyText')">
                                <!--优先级-->
                                <el-table-column 
                                    :label="$t('slb.text.priority')" 
                                    key="priority"
                                    >
                                    <template slot="header" slot-scope="scope">
                                        <el-tooltip :content="$t('slb.tooltip.priorityTip')" placement="top-start">
                                            <p class="ipAddressTip">{{$t('slb.text.priority')}}<a><i class="jc-icon-question"></i></a></p>
                                        </el-tooltip>
                                    </template>
                                    <template slot-scope="scope">
                                        <span v-if="manageStrategyButtonShow || scope.row.newPriority === 999">{{scope.row.priority | maybeEmpty}}</span>
                                        <el-input-number v-else
                                            v-model="scope.row.newPriority" 
                                            :min="1" :max="998"
                                            :controls="!!0"
                                            @input.native="(event) => changeSelectedNumber(event,scope)">
                                        </el-input-number>
                                    </template>
                                </el-table-column>
                                <!--规则类型-->
                                <el-table-column 
                                    :label="$t('slb.text.ruleType')"
                                    key="ruleType">
                                    <template slot-scope="scope">
                                        <el-form :model="scope.row"
                                            :rules="aclRules"
                                            v-if="scope.row.isNewAdd || (scope.row.newPriority === 999 && !manageStrategyButtonShow)"
                                            :ref="scope.$index + '_1'">
                                            <el-form-item 
                                                prop="newRuleType">
                                                <el-select 
                                                    :placeholder="$t('slb.sentence.ruleTypeTip')"
                                                    v-model="scope.row.newRuleType">
                                                    <el-option 
                                                        v-for="item in WhiteBlackListNames" 
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-form>
                                        <span v-else>{{scope.row.ruleTypeName | maybeEmpty}}</span>
                                    </template>
                                </el-table-column>
                                <!--IP版本-->
                                <el-table-column 
                                    :label="$t('slb.text.ipVersion')"
                                    key="ipVersion">
                                    <template slot-scope="scope">
                                        <span>{{transformIpVersion(scope.row.ipVersion) | maybeEmpty}}</span>
                                    </template>
                                </el-table-column>  
                                <!--IP地址/地址段-->
                                <el-table-column
                                    :label="$t('slb.text.ipAddressOrCidr')"
                                    key="ipCidr">
                                    <template slot-scope="scope">
                                        <span v-if="manageStrategyButtonShow || scope.row.newPriority === 999">{{scope.row.ipCidr | maybeEmpty}}</span>
                                        <el-form v-else
                                            :model="scope.row" :rules="aclRules"
                                            :ref="scope.$index + '_2'">
                                            <el-form-item 
                                                prop="newIpCidr">
                                                <el-input 
                                                    :placeholder="$t('slb.sentence.aclIpTip')"
                                                    v-model="scope.row.newIpCidr">
                                                </el-input>                                          
                                            </el-form-item>
                                        </el-form>
                                    </template>
                                </el-table-column>                        
                                <!--操作-->
                                <el-table-column key="operation"
                                    :label="$t('listPage.tableLabel.operation')">
                                    <template slot-scope="scope" >
                                        <a href="javascript:void(0)"
                                            v-if="scope.row.priority !== 999" 
                                            @click="deleteAcl(scope)">
                                            {{$t('slb.operations.delete.name')}}
                                        </a>
                                    </template>
                                </el-table-column>
                            </el-table> 
                        </div>
                        <section class="jc-container-acl-operations" v-show="!manageStrategyButtonShow">
                            <a @click="addAclRow" class="add-acl-button">
                                <i class="jc-icon-plus"></i>
                                {{$t('slb.text.addOneAcl')}}
                            </a>
                            <div class="buttons">
                                <el-button @click="doClose">{{ $t('listPage.text.cancelButton') }}</el-button>
                                <el-button type="primary" @click="doConfirm" :disabled="!!0">
                                    {{ $t('listPage.text.sureButton') }}
                                </el-button>
                            </div>
                        </section>
                    </el-tab-pane>
                    <!-- 个性化配置 -->
                    <el-tab-pane :label="$t('slb.text.customSetting')" name="custom" v-if="ifHttp || ifHttps"
                        :disabled="activeTab==='custom'">
                        <el-form ref="custom-form" label-width="80px">
                            <el-form-item :label="$t('slb.text.customSetting') | withColon" >
                                <el-radio-group 
                                    v-model="selectCustomSetting" 
                                    @change="changeCustomSetting">
                                    <el-radio v-for="item in SwitchConstant" :key="item.label" :label="item.value">
                                        {{item.label}}
                                    </el-radio>
                                </el-radio-group>
                                <el-tooltip effect="dark" class="ml10" placement="right">
                                    <div slot="content" class="my-os-disk-tip">{{$t('slb.sentence.customSettingTip')}}
                                    </div>
                                    <a><i class="jc-icon-question"></i></a>
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item 
                                v-if="selectCustomSetting === 'on'"
                                :label="$t('slb.text.codeAllocation') | withColon">
                                <el-input v-if="isCodeAllocationShow"
                                    type="textarea"
                                    v-model="codeAllocation" 
                                    :autosize="{ minRows: 4, maxRows: 8}"
                                    class="code-allocation">
                                </el-input>
                                <section v-else>
                                    <div class="code-allocation">{{detailData.codeConfig}}</div>
                                    <el-button type="text" icon="jc-icon-edit" @click="showCodeAllocation">
                                    </el-button>
                                </section>
                            </el-form-item>
                            <el-form-item class="code-allocation-operation" v-show="isCodeAllocationShow">
                                <section class="code-allocation-buttons">
                                    <el-button size="mini" @click="hideCodeAllocation">{{ $t('listPage.text.cancelButton') }}</el-button>
                                    <el-button size="mini" type="primary" @click="submitCodeAllocation" :disabled="!codeAllocation">
                                        {{ $t('listPage.text.sureButton') }}
                                    </el-button>
                                </section>
                             </el-form-item>
                        </el-form>
                    </el-tab-pane>    
                </el-tabs>
            </div>
        </div>
        <!--删除SLB组件-->
        <delete-listener :dialogVisible="deleteListenerVisible" :params="deleteListenerData"
            @refreshList="jumpToUp" @ifDialogVisible="syncBindDialog">
        </delete-listener>
        <!--添加域名-->
        <add-domain 
            v-if="addDomainVisible"
            :dialogVisible.sync="addDomainVisible" 
            :currentDomainsQuantities="sni.total"
            :region="region"
            :listenerId="listenerId"
            @addComplete="updateDomainList('refresh')">
        </add-domain>
        <!--编辑域名-->
        <modify-domain 
            v-if="modifyDomainVisible"
            :dialogVisible.sync="modifyDomainVisible" 
            :currentDomain="currentDomain"
            :region="region"
            :listenerId="listenerId"
            @modifyComplete="updateDomainList('refresh')">
        </modify-domain>
        <!--删除域名-->
        <delete-domain 
            :dialogVisible.sync="deleteDomainVisible" 
            :currentDomain="currentDomain"
            :region="region"
            :listenerId="listenerId"
            @deleteDomainComplete="updateDomainList('refresh')">
        </delete-domain>
        <!--删除策略-->
        <delete-strategy 
            :dialogVisible.sync="deleteStrategyVisible" 
            :currentStrategy="currentStrategy"
            :region="region"
            :listenerId="listenerId"
            @deleteStrategyComplete="updateAcllist('refresh')">
        </delete-strategy>
        <!--关闭个性化设置-->
        <close-custom-setting             
            :dialogVisible.sync="closeCustomDialogVisible" 
            :region="region"
            :listenerId="listenerId"
            @closeCustomComplete="updateCustomSetting">
        </close-custom-setting>
    </div>
</template>

<script>
import {
    PopStatus,
    ValidOrErrorConstant,
    AlgorithmNameMapConstant,
    OnOrOffMapConstant,
    ListenerOperationConstant,
    CookiesConstant,
    SwitchConstant,
    WhiteBlackListNameConstant,
    WhiteBlackListNames
} from '@/common/Constants';
import {initialPage,initialPageSize,emptyValue} from '@/common/ConstParam';
import { deepCopy, transformIpType} from '@/common/tool';
import { operations } from '@/common/ListenerPopHelper';
import ServerGroup from '@/components/slb/detail/ServerGroup';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
const initialRuleType = '';
const initialIpversion = 'IPv4';
import DeleteListener from '@/components/slb/detail/listener/delete/Delete';
import AddDomain from '@/components/slb/addDomain/AddDomain';
import ModifyDomain from '@/components/slb/modifyDomain/ModifyDomain';
import DeleteDomain from '@/components/slb/deleteDomain';
import DeleteStrategy from '@/components/slb/deleteStrategy';
import CloseCustomSetting from '@/components/slb/closeCustomSetting';
import {getListenerAclApi, getListenerDetailApi, getListenerSniListApi, getServerGroupDetailApi, postListenerPrivateConfigApi, editListenerAclApi} from '@/api/lb/listener/actions'
import * as Reg from "@/common/reg";
import * as BM from "@/common/bare-metal";
export default {
    components: {
        ServerGroup,
        dropDownOperation,
        DeleteListener,
        AddDomain,
        ModifyDomain,
        DeleteDomain,
        DeleteStrategy,
        CloseCustomSetting
    },
    data() {
        //验证名称
        const validateName = (rule, value, callback) => {
            const reg = Reg.name;
            if (!reg.test(value)) {
                callback(new Error());
            } else {
                callback();
            }
        };
        // 校验IP是否为空
        const cidrInputValidator = (rule, value, callback) => {
            if (!value) {
                this.aclRuleFormTag.newIpCidr = ValidOrErrorConstant.ERROR;
                return callback(new Error(this.$t('slb.sentence.forbiddenEmportyIp')));
            }
            if (!Reg.ipv4Cidr.test(value)) {
                this.aclRuleFormTag.newIpCidr = ValidOrErrorConstant.ERROR;
                return callback(new Error(this.$t('slb.sentence.legalIpRequire')));
            }
            this.aclRuleFormTag.newIpCidr = ValidOrErrorConstant.VALID;
            callback();
        };
        // 校验规则类型是否为空
        const ruleTypeSelectValidator = (rule, value, callback) => {
            if (!value) {
                this.aclRuleFormTag.newRuleType = ValidOrErrorConstant.ERROR
                callback(new Error(this.$t('slb.sentence.ruleTypeTip')));
            }
            this.aclRuleFormTag.newRuleType = ValidOrErrorConstant.VALID;
            callback();
        }
        return {
            clientToken: Normal.getClientToken(),
            // 负载均衡实例ID
            loadBalancerId: '',
            region: '',
            // 监听器ID
            listenerId: '',
            selectOperate: '1',
            headersName:'',
            detailData: {},
            descriptionFlag: false,
            editObj: {
                editName: '',
            },
            nameFlag: false,
            totalFee: 0,
            totalDiscount: 0,
            totalPrice: 0,
            minBandwidth: 0,
            rules: {
                editName: [
                    {validator: validateName}
                ],
            },
            timer: [],
            ruleFormTag: {
                editName: ValidOrErrorConstant.VALID,
            },
            pageSize: initialPageSize,
            pageSizes: [20, 50, 100], // 可选每页展示多少条
            total: 0,
            currentPage: initialPage,
            loading: false,
            activeTab: 'source',
            // 当前监听器支持的操作
            availableOperatesArray: [],
            // 所有可能的监听器操作
            listenerOperatesArray: [
                'EDIT', /* 编辑 */
                'OPEN', /* 开启 */
                'CLOSE', /* 关闭 */
                'DELETE', /* 删除 */
            ],
            // 服务器组详情数据
            serverGroupData: {},
            // 删除监听器弹框是否可见
            deleteListenerVisible: false,
            deleteListenerData: {},
            // 默认的健康检查IP
            defaultHealthCheckIp: '100.64.0.0/10',
            sni: {
                ListData: [],
                refreshLoading: false,
                currentPage: initialPage,
                pageSize: initialPageSize,
                pageSizes: [20, 50, 100],
                total: 0,
            },
            currentDomain: {},
            addDomainVisible: false,
            modifyDomainVisible: false,
            deleteDomainVisible: false,
            // acl规则
            aclRules: {
                newIpCidr: [
                    {
                        trigger: 'blur', validator: cidrInputValidator, required:true
                    }
                ],
                newRuleType: [
                    { trigger: 'change', required: true, validator: ruleTypeSelectValidator }
                ],
            },
            aclRuleFormTag: {
                newIpCidr: ValidOrErrorConstant.VALID,
                newRuleType: ValidOrErrorConstant.VALID,
            },
            manageStrategyButtonShow: true,
            acl: {
                ListData: [],
                refreshLoading: false,
                maxHeight: 700
            },
            deleteStrategyVisible: false,
            currentStrategy: {},
            // 优先级输入定时器
            inputNumberTimeout: null,
            //个性化设置默认选择
            selectCustomSetting: 'off',
            codeAllocation: '',
            isCodeAllocationShow: false,
            closeCustomDialogVisible: false,
        };
    },
    computed: {
        AlgorithmNameMapConstant: () => AlgorithmNameMapConstant,
        OnOrOffMapConstant: () => OnOrOffMapConstant,
        ValidOrErrorConstant: () => ValidOrErrorConstant,
        CookiesConstant: () => CookiesConstant,
        SwitchConstant: () => SwitchConstant,
        WhiteBlackListNames: () => WhiteBlackListNames,
        // 健康检查是否开启
        ifHealthCheckOn() {
            return this.detailData.healthCheck === 'on'
        },
        ifSessionOn() {
            return this .detailData.stickySession ==='on'
        },
        // 监听器是否开启
        ifRunning() {
            return this.detailData.status === 'active'
        },
        //是否是http
        ifHttp() {
            return this.detailData.protocolName === 'HTTP'
        },
        //是否是https
        ifHttps() {
            return this.detailData.protocolName === 'HTTPS'
        },
        //是否是UDP
        ifUdp() {
            return this.detailData.protocolName === 'UDP' 
        }
    },

    mounted() {
        this.listenerId = this.$route.query.id;
        this.region = this.$route.query.region;
        this.activeTab = this.$route.query.activeTab;
        let activeTab = this.activeTab;
        this.getListenerData(true);
        if (activeTab === 'sni') {
            this.getSniList();
        }
        if (activeTab === 'access') {
            this.getListenerAclList()
        }
    },
    destroyed() {
        clearTimeout(this.inputNumberTimeout);
    },
    watch: {
        selectCustomSetting(newVal, oldVal) {
            if (newVal === 'off') {
                this.hideCodeAllocation();
            }
        }
    },
    methods: {
        transformIpVersion(ipType) {
            return transformIpType(ipType)
        },
        changeTab(tab) {
            let tabName = tab.name;
            if (tabName === 'source') {
                this.getListenerData(true);
            }  
            if (tabName === 'sni') {
                this.getSniList();
            }
            if (tabName === 'access') {
                this.getListenerAclList()
            }
        },
        refreshData() {
            this.getListenerData(true);
        },
        updateDomainList(type) {
            if (type === 'refresh') {
                this.sni.currentPage = initialPage;
                this.sni.pageSize = initialPageSize;
            }
            this.getSniList();
        },

        updateAcllist() {
            this.getListenerAclList();
        },
        setEdit(type, data) {
            if (type === 'name') {
                this.nameFlag = true;
                this.ruleFormTag.editName = ValidOrErrorConstant.VALID;
                this.editObj.editName = data;
                setTimeout(() => {
                    try {
                        $('.jc-form-name-input input').focus();
                    } catch (e) {
                    }
                }, 200);
            } else {
                this.descriptionFlag = true;
                this.ruleFormTag.editdescription = 0;
                this.editObj.editdescription = $.trim(data);
            }
        },
        cancelDes() {
            this.editObj.editName = '';
            this.editObj.editdescription = '';
            this.descriptionFlag = false;
            this.nameFlag = false;
            if (this.$refs.editdescription != undefined) {
                this.$refs.editdescription.resetField();
            }
            if (this.$refs.editName != undefined) {
                this.$refs.editName.resetField();
            }
        },
        /**
        * 用于修改某个信息项，弹出对话框并确认
        * @param {string} type - 信息项对应的类别
        */
        confirmModify(type) {
            this.$refs.editObj.validate(async (valid) => {
                if (!valid) {
                    if (type === 'name' && this.$refs.editName.validateState === 'error') {
                        this.ruleFormTag.editName = this.$refs.editName.validateState;
                        return;
                    }
                }
                switch (type) {
                    // 修改监听器名称
                    case 'name':
                        if (this.editObj.editName === this.detailData.name) {
                            this.nameFlag = false;
                            return;
                        }
                        const params = {};
                        for(let key in this.detailData){
                            if(this.detailData[key] !== ''){
                                params[key] = this.detailData[key]
                            }
                        }
                        params.name = this.editObj.editName;
                        const nameRes = await Ajax.post('/api/cps/listeners', params, {
                            headers: {
                              'Content-Type': 'application/json'
                            }
                        })
                        .catch(async (err) => {
                            const {response} = err.data;
                            try {
                                const json = await response.json();
                                this.$message.error(json.errmsg);
                            } catch (ex) {
                                console.log(ex);
                            }
                        });
                        this.hostName = this.detailData.name = nameRes.data.listener.name;
                        this.nameFlag = false;
                    break;
                }
                if (typeof this.$refs.editdescription !== 'undefined') {
                    this.$refs.editdescription.resetField();
                }
            });
        },
        getListenerData(initOperate = false) {
            const params = {
                region: this.region,
                listenerId: this.listenerId,
            };
            getListenerDetailApi(params)
            .then((res) => {
                const data = res.data;
                const listener = data.listener;
                this.loadBalancerId = listener.loadBalancerId;
                this.detailData = data.listener;
                this.detailData.region = this.region;
                // 格式化字段
                // 监听协议
                this.detailData.protocolName = BM.toUpper(listener.protocol);
                // 调度算法
                this.detailData.algorithmName =
                  AlgorithmNameMapConstant[BM.toUpper(listener.algorithm)];
                // 会话保持
                this.detailData.stickySessionName =
                  OnOrOffMapConstant[BM.toUpper(listener.stickySession)];
                // http2.0
                this.detailData.http2Name =
                  OnOrOffMapConstant[BM.toUpper(listener.http2)];
                // 获取真实IP
                this.detailData.realIpName = listener.realIp !== undefined ?
                OnOrOffMapConstant[BM.toUpper(this.detailData.realIp)] : '' ;
                // 健康检查
                this.detailData.healthCheckName  =
                OnOrOffMapConstant[BM.toUpper(listener.healthCheck)];
                //会议类型
                this.detailData.cookieTypeName = listener.cookieType !== undefined ?
                CookiesConstant[BM.toUpper(listener.cookieType)] : '';
                this.detailData.headersName = listener.headers !== undefined ?
                listener.headers.join() : '';
                // 个性化设置
                this.selectCustomSetting = this.detailData.personalize;
                if (initOperate) {
                    this.initOperates();
                }
                this.getServerGroupDetailData();
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
            });
        },
        getSniList() {
            this.sni.refreshLoading = true
            const params = {
                region: this.region,
                listenerId: this.listenerId,
                pageNumber: this.sni.currentPage,
                pageSize: this.sni.pageSize
            };
            getListenerSniListApi(params)
            .then((res) => {
                const domains = res.data && res.data.domainList;
                this.sni.listData = domains;
                this.sni.total = res.data.totalCount;
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.sni.refreshLoading = false;
            });
        },
        handleSniCurrentChange(val) {
            this.sni.currentPage = val;
            this.getSniList();
        },
        handleSniSizeChange() {
            this.sni.pageSize = val;
            this.getSniList();
        },
        // 操作下拉选初始化，编辑、开启/关闭、删除
        initOperates() {
            this.availableOperatesArray = this.listenerOperatesArray.map((key) => {
                const {name} = this.$t(`slb.operations.${key.toString().toLowerCase()}`);
                const item = {
                    value: ListenerOperationConstant[key],
                    name,
                    ifShow: true,
                };
                // 运行中的监听器，不能再开启
                if (key === 'OPEN' && this.ifRunning) {
                    item.ifShow = false;
                }
                // 关闭的监听器，不能再关闭
                if (key === 'CLOSE' && !this.ifRunning) {
                    item.ifShow = false;
                }
                return item;
            });
        },
        // 跳转到负载均衡详情监听器Tab页
        jumpToUp() {
            this.$router.push({
                name: 'SlbDetail',
                query: {
                    activeTabName: 'listenerList',
                    region: this.region,
                    loadBalancerId: this.loadBalancerId
                }
            });
        },
        selectOps(item) {
            if(item.value === ListenerOperationConstant.DELETE){
                this.deleteListenerVisible = true;
                this.deleteListenerData = this.detailData
            }
            operations(item.value, this, this.detailData, 'detail');
        },
        updateServerData($msg = null) {
            this.clientToken = Normal.getClientToken();
            this.getListenerData(false);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getMonitorLogs();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.getMonitorLogs();
        },
        // 跳转到服务器组详情
        jumpToServerGroupDetail(){
            this.$router.push({
                name: 'SlbDetail',
                query: {
                    activeTabName: 'defaultServerGroup',
                    region: this.region,
                    loadBalancerId: this.serverGroupData.loadBalancerId,
                    serverGroupIds: this.serverGroupData.serverGroupId
                }
            });
        },
        // 获取服务器组详情
        getServerGroupDetailData(){
            const param = {
                region: this.region,
                serverGroupId: this.detailData.serverGroupId
            }
            getServerGroupDetailApi(param)
            .then((res) => {
                this.serverGroupData = res.data.serverGroup
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
            })
        },
        // 同步绑定资源子组件传出来的dialog是否展示
        syncBindDialog(data) {
            this.deleteListenerVisible = data;
        },

        addDomain() {
            this.addDomainVisible = true;
        },

        modifyDomain(row) {
            this.currentDomain = row;
            this.modifyDomainVisible = true;
        },

        closeModifyDomainDialog() {
            this.modifyDomainVisible = false;
        },

        deleteDomain(row) {
            this.currentDomain = row;
            this.deleteDomainVisible = true;
        },

        changeCustomSetting(val) {
            if (val === 'off') {
                this.closeCustomDialogVisible = true;
            }
        },

        submitCodeAllocation() {
            let codeAllocation = this.codeAllocation.replace(/\n/g,'').replace(/\r/g,'');
            let param = {
                codeConfig: codeAllocation,
                listenerId: this.listenerId,
                personalize: this.selectCustomSetting,
                region: this.region
            }
            postListenerPrivateConfigApi(param)
            .then((res) => {
                if (res.data && res.data.success) {
                    this.detailData.codeConfig = codeAllocation;
                    this.hideCodeAllocation();
                }
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
            })
        },

        hideCodeAllocation() {
            this.isCodeAllocationShow = false;
        },

        showCodeAllocation() {
            this.codeAllocation = this.detailData.codeConfig;
            this.isCodeAllocationShow = true;
        },

        updateCustomSetting() {
            this.detailData.codeConfig = '';
        },
        manageStrategy() {
            this.manageStrategyButtonShow = false;
        },

        getListenerAclList() {
            this.acl.refreshLoading = true;
            let params = {
                region: this.region,
                listenerId: this.listenerId,
            };
            getListenerAclApi(params).then((res) => {
                let aclRules = res.data && res.data.aclRuleList;
                aclRules = aclRules.map(item => {
                    item.newPriority = item.priority;
                    item.newIpCidr = item.ipCidr;
                    item.newRuleType = item.ruleType;
                    item.ruleTypeName = WhiteBlackListNameConstant[item.ruleType];
                    return item 
                });
                this.acl.listData = aclRules;
            })
            .catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                  console.log(ex);
                }
            })
            .finally(() => {
                this.acl.refreshLoading = false;
            });
        },

        deleteAcl(scope) {
            let manageStrategyButtonShow = this.manageStrategyButtonShow;
            if (manageStrategyButtonShow) {
                this.currentStrategy = scope.row;
                this.deleteStrategyVisible = true;
            } else {
                this.acl.listData.splice(scope.$index, 1);
            }
        },

        addAclRow() {
            if(this.aclRuleFormTag.newIpCidr === ValidOrErrorConstant.ERROR || this.aclRuleFormTag.newRuleType === ValidOrErrorConstant.ERROR) {
                return
            }
            let initValid = true;
            let reg = /^\d+_\d+$/;
            let formValidKeys = Object.keys(this.$refs).filter(item => {
                return reg.test(item) && item
            });
            formValidKeys.map(item => {
                if(this.$refs[`${item}`]) {
                    this.$refs[`${item}`].validate((valid) => {
                        initValid = initValid && valid;
                        if (!valid) {
                            return false;
                        }
                    });
                }
            });
            if (!initValid) {
                return
            }
            const row = {
                "priority": emptyValue,
                "newPriority": emptyValue,
                "ipCidr": emptyValue,
                "newIpCidr": emptyValue,
                "ruleType": initialRuleType,
                "newRuleType": initialRuleType,
                "ipVersion": initialIpversion,
                "isEditing": true,
                "isNewAdd": true
            };
            this.acl.listData.push(row);
        },

        doClose() {
            this.manageStrategyButtonShow = true;
            this.getListenerAclList();
        },

        doConfirm() {
            let aclRuleList = this.acl.listData.map(item => {
                return {
                    ipCidr: item.newIpCidr,
                    ipVersion: item.ipVersion,
                    priority: item.newPriority,
                    ruleId: item.ruleId,
                    ruleType: item.newRuleType
                }
            });
            let params = {
                aclRuleList,
                listenerId: this.listenerId,
                region: this.region,
                personalize: this.selectCustomSetting,
            }
            editListenerAclApi(params).then(res => {
                if (res.data && res.data.success) {
                    this.getListenerAclList();                  
                }
            }).catch(async (err) => {
                const {response} = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                  console.log(ex);
                }
            })
            .finally(() => {
                this.doClose();
            });
        },

        // 只能输入整数
        changeSelectedNumber(event,scope){
            clearTimeout(this.inputNumberTimeout);
            this.inputNumberTimeout = setTimeout(() => {
                let v = event.target.value;
                v = v.replace(Reg.nonNumeric, '');
                scope.row.newPriority = v;
            }, 200)
        },

    }
};
</script>

<style lang="scss">
    @import '~@/assets/scss/paginationCommon.scss';
    @import '~@/assets/scss/detailCommon.scss';
    @import 'style';
</style>






// WEBPACK FOOTER //
// src/views/slb/detail/listener/detail/Detail.vue